import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { alterTripField, isServiceField, trackError } from 'utils/helpers';
import { discardBooking } from '../booking';
import { saveAccommodationSearchFormValues } from '../ui/sealink';

const createScheduledTripReservationStarted = createAction(
  'reservation/createScheduledTripReservationStarted'
);
const createScheduledTripReservationSucceeded = createAction(
  'reservation/createScheduledTripReservationSucceeded'
);
const createScheduledTripReservationFailure = createAction(
  'reservation/createScheduledTripReservationFailure'
);

const createScheduledTripReservation =
  (tripValues, discardExisting = false, ferryGrouping) =>
  (dispatch, getState) => {
    dispatch(createScheduledTripReservationStarted());

    const state = getState();
    const allServices = state.services.ferryGrouping[0];

    const params = tripValues.map(
      ({
        product_type_id,
        route_id,
        forwardSegment,
        returnSegment,
        add_return = false,
        departureSegmentId,
      }) => {
        const serviceField = isServiceField({
          departureSegmentId,
          allServices,
        });
        return {
          product_type_id,
          route_id,
          forward: alterTripField(serviceField, forwardSegment),
          return: alterTripField(serviceField, returnSegment),
          add_return,
          segments: add_return ? ['forward', 'return'] : ['forward'],
        };
      }
    );

    const firstStep = () =>
      discardExisting ? dispatch(discardBooking()) : Promise.resolve(true);

    return firstStep()
      .then(() =>
        EcomEngineAPI.reservation.createScheduledTrip({
          reservations: params,
          ferryGrouping,
        })
      )
      .then((json) => {
        dispatch(createScheduledTripReservationSucceeded(json));
        dispatch(saveAccommodationSearchFormValues({}));
        return json;
      })
      .catch((error) => {
        trackError(error);
        dispatch(createScheduledTripReservationFailure(error.message));
        return Promise.reject(error);
      });
  };

export {
  createScheduledTripReservationStarted,
  createScheduledTripReservationSucceeded,
  createScheduledTripReservationFailure,
  createScheduledTripReservation,
};
